import React, { FC } from 'react';
import s from "./ProgressBar.module.css";
import Button from "../../../../shared/ui/button/Button";
import arrow from '../../../../assets/img/arrow_back.svg';

interface ProgressBarProps {
    step: number;
    totalSteps: number;
    setStep: React.Dispatch<React.SetStateAction<number>>;
}

const ProgressBar: FC<ProgressBarProps> = ({ step, totalSteps, setStep }) => {
    const calculateProgress = () => {
        return ((step + 1) / totalSteps) * 100;
    };

    return (
        <div className={s.container}>
            <button className={s.btn}
                onClick={() => setStep((prev) => Math.max(0, prev - 1))}>
                <img src={arrow}/>
            </button>


            <div className={s.progressBar}>
                <div
                    className={s.progress}
                    style={{ width: `${calculateProgress()}%` }}
                ></div>
            </div>
        </div>
    );
};

export default ProgressBar;
